<template>
    <div id="mapContainer">
        <div id="map" ref="map" v-show="loaded">
            <div id="toggleFeatureTable" class="esri-widget">
                <button v-on:click="toggleFeatureTable()"
                        id="featureTableButton"
                        v-bind:class="{active: showFeatureTable}"
                        title="Feature Table"
                        class="esri-icon-table">
                </button>
            </div>
            <span id="measureTool" class="esri-widget">
                <button v-on:click="measureDistance()"
                        v-bind:class="{active: distanceActive}"
                        class="esri-icon-measure-line"
                        title="Measure Distance">
                </button>
                <button v-on:click="measureArea()"
                        v-bind:class="{active: areaActive}"
                        class="esri-icon-measure-area"
                        title="Measure Area">
                </button>
                <button v-on:click="measureClear()"
                        class="esri-icon-erase"
                        title="Clear Measurements">
                </button>
            </span>
<!--            <div id="selectTools">-->
<!--                <span id="selectButton" class="esri-widget">-->
<!--                    <button v-on:click="selectTool('add')"-->
<!--                            v-bind:class="{active: selectActive}"-->
<!--                            class="esri-icon-plus-circled"-->
<!--                            title="Select features from the map">-->
<!--                    </button>-->
<!--                </span>-->
<!--                <span id="deselectButton" class="esri-widget">-->
<!--                    <button v-on:click="selectTool('remove')"-->
<!--                            v-bind:class="{active: deselectActive}"-->
<!--                            class="esri-icon-minus-circled"-->
<!--                            title="Deselect features from map">-->
<!--                    </button>-->
<!--                </span>-->
<!--                <span class="esri-widget">-->
<!--                    <button v-on:click="clearSelection()"-->
<!--                            class="esri-icon-erase"-->
<!--                            title="Clear all selected features">-->
<!--                    </button>-->
<!--                </span>-->
<!--            </div>-->

            <!--<span id="zoomToSelectedButton" class="esri-widget">
                <button v-on:click="zoomToSelectedFeatures()"
                        v-show="selectedFeatures.length > 0"
                        class="esri-icon-default-action"
                        title="Zoom to Selected Features">
                </button>

            </span>-->
            <div id="homeButton" class="esri-widget">
                <button v-on:click="goToHome()"
                        class="esri-icon-home"
                        title="Return to Region View">
                </button>
            </div>
            <div id="selectingPopup" v-show="this.queryingSelection"
                 style="background: #FFFFFF;
                width: 30%;
                margin-left: 25%;
                margin-top: 5%;
                padding: 5px;
                height: fit-content;
                font-weight: bold;
                border-radius: 5px;
                border-color: black;
                border-width: 3px;
                opacity: 80%;
                text-align: center;">
                <h3><img src="../assets/loading.gif" class="loadingSpinner"/>Updating selection...</h3>
                <p style="text-align: center"> This process may take several minutes if many features are being selected
                    or deselected.
                </p>
            </div>
        </div>
        <div id="featureTable" ref="featureTable" v-show="showFeatureTable && !focusAmendment">
        </div>
        <div id="amendmentFeatureTable" ref="amendmentFeatureTable" v-if="amendmentOpen" v-show="showFeatureTable && focusAmendment">
        </div>
    </div>
</template>

<script>
import {loadModules} from 'esri-loader';

let tinycolor = require('tinycolor2');

export default {
    name: 'MainMap',
    components: {},
    props: [
        "filter_project_name",
        "filter_project_type",
        "filter_construction_year",
        "filter_FAC",
        "filter_street",
        "filter_jurisdiction",
        "construction_years",
        "FACs",
        'project_types',
        'jurisdictions',
        'symbology',
        'showTable',
        'focus',
        'amendmentOpen'
    ],
    data: function () {
        return {
            showFeatureTable: false,
            distanceActive: false,
            deselectActive: false,
            selectActive: false,
            areaActive: false,
            loaded: false,
            applyFilterToTable: true,
            queryingSelection: false,
            selectedFeatures: [],
            selectMode: "add",
            focusAmendment: false,
        }
    },
    computed: {
        filter: function () {
            let filter = {}
            let parts = [];
            if (this.filter_project_name && this.filter_project_name.length) {
                let name = `rpt_rte_na in (${this.filter_project_name.map(f => `'${f}'`).join(',')})`;
                parts.push(name);
            }
            if (this.filter_project_type && this.filter_project_type.length) {
                let valid_project_types = this.filter_project_type.filter(f => f !== 'Missing');
                let type = `projtype in (${valid_project_types.map(f => `'${f}'`).join(',')})`;

                if (valid_project_types.length && valid_project_types.length < this.filter_project_type.length) {
                    parts.push('(' + type + ' OR projtype is null)');
                } else if (valid_project_types.length === 0) {
                    parts.push('projtype is null');
                } else {
                    parts.push(type);
                }
            }
            if (this.filter_construction_year && this.filter_construction_year.length) {
                let valid_construction_years = this.filter_construction_year.filter(f => f !== 'Missing');
                let constructionyear = `conyear in (${valid_construction_years.map(f => `${f}`).join(',')})`;

                if (valid_construction_years.length && valid_construction_years.length < this.filter_construction_year.length) {
                    parts.push('(' + constructionyear + ' OR conyear is null)');
                } else if (valid_construction_years.length === 0) {
                    parts.push('conyear is null');
                } else {
                    parts.push(constructionyear);
                }
            }
            if (this.filter_FAC && this.filter_FAC.length) {
                let valid_FACs = this.filter_FAC.filter(f => f !== 'Missing');
                let FAC = `fac in (${valid_FACs.map(f => `'${f}'`).join(',')})`;

                if (valid_FACs.length && valid_FACs.length < this.filter_FAC.length) {
                    parts.push('(' + FAC + ' OR fac is null)');
                } else if (valid_FACs.length === 0) {
                    parts.push('fac is null');
                } else {
                    parts.push(FAC);
                }
            }

            if (this.filter_jurisdiction && this.filter_jurisdiction.length) {
                let valid_jurisdictions = this.filter_jurisdiction.filter(f => f !== 'Missing');
                let jurisdiction = `jurisdiction in (${valid_jurisdictions.map(f => `'${f}'`).join(',')})`;

                if (valid_jurisdictions.length && valid_jurisdictions.length < this.filter_jurisdiction.length) {
                    parts.push('(' + jurisdiction + ' OR jurisdiction is null)');
                } else if (valid_jurisdictions.length === 0) {
                    parts.push('jurisdiction is null');
                } else {
                    parts.push(jurisdiction);
                }
            }

            if (this.filter_street) {
                let street = `UPPER(rpt_loc_de) LIKE '%${this.filter_street.toUpperCase()}%'`;
                parts.push(street);
            }

            if (parts.length === 1) {
                filter.where = parts[0]
            } else {
                filter.where = parts.join(' and ')
            }
            console.log(filter);
            return filter
        },
        symbolSet: function () {
            const typeValueInfos = [
              this.createFillSymbol("Bridge", "#a65628"),
              this.createFillSymbol("Operations", "#984ea3"),
              this.createFillSymbol("Other", "#377eb8"),
              this.createFillSymbol("Pavement", "#ff7f00"),
              this.createFillSymbol("Ped/Bike", "#4daf4a"),
              this.createFillSymbol("Safety", "#e41a1c"),
              this.createFillSymbol("Transit", "#dcce7d"),
            ];

            let typeRenderer = {
                legendOptions: {title: "2026-2029 TIP Project Type"},
                type: "unique-value",
                field: "projtype",
                uniqueValueInfos: typeValueInfos,
            }

            let amendmentTypeRenderer = {
                legendOptions: {title: "Current Amendment Project Type"},
                type: "unique-value",
                field: "projtype",
                uniqueValueInfos: typeValueInfos
            }


            const yearValueInfos = [
                this.createFillSymbol(2025, "#FF00FF"),
                this.createFillSymbol(2026, "#a65628"),
                this.createFillSymbol(2027, "#377eb8"),
                this.createFillSymbol(2028, "#ff7f00"),
                this.createFillSymbol(2029, "#4daf4a"),
            ]
            let yearRenderer = {
                type: "unique-value",
                field: "conyear",
                legendOptions: {title: "Planned Construction Year"},
                uniqueValueInfos: yearValueInfos,
            }

            let amendmentYearRenderer = yearRenderer;

            let jurisRenderer = {
                type: "unique-value",
                field: "jurisdiction",
                legendOptions: {title: "Project Jurisdiction"},
                uniqueValueInfos: [
                    this.createFillSymbol("City or Village", "#a65628"),
                    this.createFillSymbol("County", "#984ea3"),
                    this.createFillSymbol("SEMCOG", "#377eb8"),
                    //this.createFillSymbol("Region", "#ff7f00"),
                    this.createFillSymbol("State", "#4daf4a"),
                    this.createFillSymbol("Transit", "#e41a1c"),

                ]
            }

            let amendmentJurisRenderer = jurisRenderer;

            let TIPSym = typeRenderer;
            let AmendSym = amendmentTypeRenderer;
            if (this.symbology) {
                if (this.symbology === "Project Type") {
                    TIPSym = typeRenderer;
                    AmendSym = amendmentTypeRenderer;
                } else if (this.symbology === "Obligation Year") {
                    TIPSym = yearRenderer;
                    AmendSym = amendmentYearRenderer;
                } else if (this.symbology === "Jurisdiction") {
                    TIPSym = jurisRenderer;
                    AmendSym = amendmentJurisRenderer;
                }
            }
            return {"TIP": TIPSym, "Amendment": AmendSym,};
        },
    },
    methods: {
        query: function (data_field, vue_field, layer) {
            let vue_this = this;
            let query = vue_this[layer].createQuery();
            query.outFields = [data_field];
            query.returnDistinctValues = true;
            query.returnGeometry = false;
            vue_this[layer].queryFeatures(query)
                .then(function (response) {
                    response.features.forEach(f => vue_this[vue_field].push(f.attributes[data_field]))
                });
        },
        getData: function (layer) {
            this.query('conyear', 'construction_years', layer)
            this.query('fac', 'FACs', layer)
            this.query('projtype', 'project_types', layer)
            this.query('jurisdiction', 'jurisdictions', layer)
        },
        createFillSymbol: function (value, color) {
            let tempColor = tinycolor(color);
            let transparentColor = [tempColor._r, tempColor._g, tempColor._b, 0.25];
            return {
                value: value,
                symbol: {
                    type: "simple-fill",
                    style: "solid",
                    color: transparentColor,
                    outline: {
                        style: "solid",
                        type: "simple-line",
                        width: '3px',
                        color: color,
                    }
                },
                label: value
            };
        },
        toggleFeatureTable: function () {
            this.showFeatureTable = !this.showFeatureTable;
            if (this.showFeatureTable) {
                this.$emit("tableToggle", "y");
            } else {
                this.$emit("tableToggle", "n");
            }
        },
        measureDistance: function () {
            this.measurement.activeTool = "distance";
            this.distanceActive = true;
            this.areaActive = false;
        },
        measureArea: function () {
            this.measurement.activeTool = "area";
            this.distanceActive = false;
            this.areaActive = true;
        },
        measureClear: function () {
            this.measurement.clear();
            this.distanceActive = false;
            this.areaActive = false;
        },

        goToHome: function () {
            this.view.goTo({
                center: [-83.2437186609522, 42.454430721108764],
                zoom: 8
            });
        },
        selectTool: function (mode) {
            this.distanceActive = false;
            this.areaActive = false;

            if (mode === "remove") {
                this.deselectActive = true;
                this.selectMode = "remove";
            } else {
                this.selectActive = true;
                this.selectMode = "add"
            }
            this.view.graphics.removeAll();
            this.view.popup.close();
            this.selectSketch.create("polygon");
        },
        selectFeatures: function (geometry) {
            const vue_this = this;
            this.view.graphics.removeAll();
            const query = {
                geometry: geometry,
                outFields: ["*"]
            }
            console.log("Querying features by geometry... (This may take a few minutes for large numbers of features)");
            this.queryingSelection = true;
            this.view.whenLayerView(this.tip_tableLayer).then(f => {
                f.queryFeatures(query).then(function (results) {
                    const graphics = results.features;
                    if (graphics.length > 0) {
                        // This may be a race condition, but it's worked so far in testing. Without the setTimeout,
                        // the code has been prone to displaying on-map features as non-selected if they're already
                        // selected when included in a new selection box, functioning more like a toggle than a selection.
                        setTimeout(() => {
                            if (vue_this.selectMode === "add") {
                                vue_this.featureTable.selectRows(results.features);
                            } else {
                                vue_this.featureTable.deselectRows(results.features);
                            }
                            vue_this.queryingSelection = false;
                            vue_this.selectActive = false;
                            vue_this.deselectActive = false;
                            console.log("Geometry selection complete.")
                        }, 250);
                    } else {
                        console.log("No features in area, nothing selected.");
                        vue_this.queryingSelection = false;
                        vue_this.selectActive = false;
                        vue_this.deselectActive = false;
                    }
                });
            });
        },
        clearSelection: function () {
                        this.distanceActive = false;
            this.areaActive = false;
            this.selectActive = false;
            this.deselectActive = false;

            const promise1 = new Promise((resolve) => {
                                this.queryingSelection = true;
                resolve();
            });

            promise1.then(() => {
                this.featureTable.clearSelection();
                this.queryingSelection = false;
            });
        },
        zoomToSelectedFeatures: function () {
            // Create a query off of the feature layer
            const query = this.tip_tableLayer.createQuery();
            // Iterate through the features and grab the feature's objectID
            const featureIds = this.selectedFeatures.map((result) => {
                return result.feature.getAttribute(this.tip_tableLayer.objectIdField);
            });
            // Set the query's objectId
            query.objectIds = featureIds;
            // Make sure to return the geometry to zoom to
            query.returnGeometry = true;

            // Call queryFeatures on the feature layer and zoom to the resulting features
            this.tip_tableLayer.queryFeatures(query).then((results) => {
                let tempResults = results.features.map((feature) => {
                    return feature.geometry
                });
                this.view.goTo(tempResults).catch(function (error) {
                    if (error.name !== "AbortError") {
                        console.error(error);
                    }
                })
            });
        },
    },
    mounted() {
        // lazy load the required ArcGIS API for JavaScript modules and CSS
        let vue_this = this;
        loadModules(['esri/Map', 'esri/views/MapView',
            "esri/Basemap", "esri/widgets/Legend", "esri/widgets/Search",
            "esri/layers/FeatureLayer", "esri/widgets/BasemapGallery",
            "esri/widgets/Expand", "esri/widgets/FeatureTable",
            "esri/widgets/Measurement", "esri/widgets/Sketch/SketchViewModel",
            "esri/layers/GraphicsLayer", "esri/core/watchUtils"], {version: '4.19', css: true})
            .then(([ArcGISMap, MapView, Basemap, Legend, Search, FeatureLayer, BasemapGallery,
                       Expand, FeatureTable, Measurement, SketchViewModel, GraphicsLayer, watchUtils]) => {

                let imageryBasemap = new Basemap({
                    portalItem: {
                        id: "665cea4a7f654208a43c41c695eb1793"
                    },
                    title: "Imagery with Labels",
                    id: "imagery",
                    thumbnailUrl: "https://semcog.maps.arcgis.com/sharing/rest/content/items/665cea4a7f654208a43c41c695eb1793/info/thumbnail/thumbnail1547042127147.png?token=ZdmLLkWrVBmzGxyfPUPiBAbUuwWCg48jP8xHmPLyUmoctftPg_LW-5YCe7vheiGi80QgAngVX9aQKV0ZsY0u4JhOE8B5IOzLtfR3g_uvbKHcB1t82wgCbSx0ur-0hIWY6PLNYzStTsiuqd8_MLDTcQBW8CU-9p_0QlcKLXR8qYkRA_SlYGYfvxNCMNaT35FdwblOHgEbZrLavTJlUZN5F5DAeZQDSegfvNQKSajOIRw."
                });

                let stateHouseBasemap2023 = new Basemap({
                    portalItem: {
                        id: "3730b4c557184974906f4dffab40b4a9"
                    },
                    title: "2023 Michigan State House Districts",
                    id: "stateHouse2023",
                    thumbnailUrl: "https://semcog.maps.arcgis.com/sharing/rest/content/items/3730b4c557184974906f4dffab40b4a9/info/thumbnail/ago_downloaded.png"
                });

                let stateSenateBasemap2023 = new Basemap({
                    portalItem: {
                        id: "828cf5d1fabb42d0aecccce4c574e461",
                    },
                    title: "2023 Michigan State Senate Districts",
                    id: "stateSenate2023",
                    thumbnailUrl: "https://semcog.maps.arcgis.com/sharing/rest/content/items/828cf5d1fabb42d0aecccce4c574e461/info/thumbnail/ago_downloaded.png"
                });
                let congressBasemap2023 = new Basemap({
                    portalItem: {
                        id: "46d0c7c69ad347ffb28ac5ef6f0d8a42"
                    },
                    title: "2023 Congressional Districts",
                    id: "congress2023",
                    thumbnailUrl: "https://semcog.maps.arcgis.com/sharing/rest/content/items/46d0c7c69ad347ffb28ac5ef6f0d8a42/info/thumbnail/ago_downloaded.png"
                });

                let transportationBasemap = new Basemap({
                    portalItem: {
                        id: "88040fcb3d904776847072f62fcb5f8e"
                    },
                    title: "Transportation with Communities",
                    id: "transportation-communities",
                    thumbnailUrl: "https://semcog.maps.arcgis.com/sharing/rest/content/items/6db68c2945dc4031a7f1817cf7d6a3d8/info/thumbnail/thumbnail1547041274700.png"
                });

                this.map = new ArcGISMap({
                    basemap: transportationBasemap
                });

                this.view = new MapView({
                    container: this.$refs.map,
                    map: this.map,
                    center: [-83.2437186609522, 42.454430721108764],
                    zoom: 8,
                    constraints: {
                      rotationEnabled: false
                    }
                });

                this.view.ui.add("homeButton", "top-left")
                let basemapGallery = new BasemapGallery({
                    source: [
                        transportationBasemap,
                        imageryBasemap,
                        congressBasemap2023,
                        stateHouseBasemap2023,
                        stateSenateBasemap2023
                    ],
                    view: this.view
                });

                let bgExpand = new Expand({
                    view: this.view,
                    content: basemapGallery,
                    expandTooltip: "Basemap Gallery"
                });

                this.view.ui.add(bgExpand, "top-left");

                let searchWidget = new Search({
                    view: this.view
                });
                let sExpand = new Expand({
                    view: this.view,
                    content: searchWidget,
                    expandTooltip: "Search by Address"
                });
                this.view.ui.add(sExpand, {
                    position: "top-left"
                });

                const oddRowStyle = "'padding: 2px; background-color: #fff'"
                const evenRowStyle = "'padding: 2px; background-color: #e2e2e2'"
                const popupTIPpoly = {
                    "title": "Project Details",
                    "content": `<table style="background-color: #222; width=100%;">
                                        <tr style=${oddRowStyle}> <td>Name:</td> <td>{rpt_rte_na}</td></tr>
                                        <tr style=${evenRowStyle}> <td>Job ID:</td> <td>{jobnet_id}</td></tr>
                                        <tr style=${oddRowStyle}> <td>Limits: </td> <td>{rpt_loc_de} </td></tr>
                                        <tr style=${evenRowStyle}> <td>Construction Year: </td> <td>{conyear} </td></tr>
                                        <tr style=${oddRowStyle}> <td>Type: </td> <td>{projtype} </td></tr>
                                        <tr style=${evenRowStyle}> <td>Lead Agency: </td> <td>{agn_name} </td></tr>
                                        <tr style=${oddRowStyle}> <td>Total Project Cost: </td> <td>&dollar;{tot_prj_co} </td></tr>
                                        <tr style=${evenRowStyle}> <td>Description of Work: </td> <td>{rpt_wk_des} </td></tr>
                                    </table><br/>
                                    <a style="padding: 5px; margin: 5px; background-color: #0f2d53; color: #fff; border-radius: 5px; box-shadow: 2px 3px #ccc" href='mailto:infocenter@semcog.org?subject=Public comment on TIP Project {jobnet_id}'>Give feedback on this project</a>`,
                    "fieldInfos": [{
                        fieldName: "tot_prj_co",
                        visible: true,
                        format: {
                            places: 0,
                            "digitSeparator": true
                        }
                    },
                    ],
                };
                const popupAmendmentPoly = {
                    "title": "Amended Project Details",
                    // <tr style=${oddRowStyle}> <td>Description of Change: </td><td>{ChangeDescription} </td></tr>
                    "content": `<table style="background-color: #222; width=100%;">
                                        <tr style=${oddRowStyle}> <td>Name:</td> <td>{rpt_rte_na}</td></tr>
                                        <tr style=${evenRowStyle}> <td>Job ID:</td> <td>{jobnet_id}</td></tr>
                                        <tr style=${oddRowStyle}> <td>Limits: </td> <td>{rpt_loc_de} </td></tr>
                                        <tr style=${evenRowStyle}> <td>Construction Year: </td> <td>{conyear} </td></tr>
                                        <tr style=${oddRowStyle}> <td>Type: </td> <td>{projtype} </td></tr>
                                        <tr style=${evenRowStyle}> <td>Lead Agency: </td> <td>{agn_name} </td></tr>
                                        <tr style=${oddRowStyle}> <td>Total Project Cost: </td> <td>&dollar;{tot_prj_co} </td></tr>
                                        <tr style=${evenRowStyle}> <td>Description of Work: </td> <td>{rpt_wk_des} </td></tr>

                                    </table><br/>
                                    <a style="padding: 5px; margin: 5px; background-color: #0f2d53; color: #fff; border-radius: 5px; box-shadow: 2px 3px #ccc" href='mailto:infocenter@semcog.org?subject=Public comment on TIP Project {jn}'>Give feedback on this project</a>`,
                    "fieldInfos": [{
                        fieldName: "tot_prj_co",
                        visible: true,
                        format: {
                            places: 0,
                            "digitSeparator": true
                        }
                    },
                    ],
                    "expressionInfos": [
                        {

                        }
                    ],
                };
                this.view.popup = {
                    dockEnabled: true,
                    dockOptions: {
                        buttonEnabled: false,
                        position: "bottom-right",
                        breakpoint: false,
                    }
                }

                this.typeRenderer = {
                    legendOptions: {title: "Project Type"},
                    type: "unique-value",
                    field: "projtype",
                    uniqueValueInfos: [
                      this.createFillSymbol("Bridge", "#a65628"),
                      this.createFillSymbol("Operations", "#984ea3"),
                      this.createFillSymbol("Other", "#377eb8"),
                      this.createFillSymbol("Pavement", "#ff7f00"),
                      this.createFillSymbol("Ped/Bike", "#4daf4a"),
                      this.createFillSymbol("Safety", "#e41a1c"),
                      this.createFillSymbol("Transit", "#dcce7d"),
                    ],
                }
                //TODO: Figure out how to define the UniqueValueInfos and the SymbolSet.TypeValueInfos in one place

                this.amendmentTypeRenderer = {
                    legendOptions: {title: "Amendment Project Type"},
                    type: "unique-value",
                    field: "projtype",
                    uniqueValueInfos: [
                      this.createFillSymbol("Bridge", "#a65628"),
                      this.createFillSymbol("Operations", "#984ea3"),
                      this.createFillSymbol("Other", "#377eb8"),
                      this.createFillSymbol("Pavement", "#ff7f00"),
                      this.createFillSymbol("Ped/Bike", "#4daf4a"),
                      this.createFillSymbol("Safety", "#e41a1c"),
                      this.createFillSymbol("Transit", "#dcce7d"),
                    ]
                }

                this.grayedEffect = "grayscale(80%) opacity(30%)";
                this.focusEffect = "";

                this.noRenderer = {
                    type: "simple",
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 0, 0],
                        outline: {
                            type: "simple-line",
                            width: '4px',
                            style: "solid",
                            color: [0, 0, 0, 0],
                        }
                    }
                }

                let countyRenderer = {
                    type: "simple",
                    symbol: {
                        type: "simple-line",
                        size: 3,
                        color: "black",
                    }
                }

                //const Adopted_URL = "https://gis.semcog.org/server/rest/services/Hosted/TIP_Projects_FY_2023_to_2026/FeatureServer/74";
                //const Adopted_URL = "https://gis.semcog.org/server/rest/services/Hosted/TIP2629_Final_2025_04_03/FeatureServer/114";
                //const Adopted_URL = "https://gis.semcog.org/server/rest/services/Hosted/TIP2629_Final_563_2025_05_12/FeatureServer/118";
                //const Adopted_URL = "https://gis.semcog.org/server/rest/services/Hosted/TIP_26_29_Projects_Oct_1_2025/FeatureServer/130";
                //const Adopted_URL = "https://gis.semcog.org/server/rest/services/Hosted/TIP_26_29_Updated_After_Amendement_25_5/FeatureServer/142";
                //const Adopted_URL = "https://gis.semcog.org/server/rest/services/Hosted/TIP_2629_Updated_After_Amendement_26_1/FeatureServer/150";
                const Adopted_URL = "https://gis.semcog.org/server/rest/services/Hosted/TIP_26_29_Updated_After_Amendment_26_3/FeatureServer/154";
                this.tip_polygons = new FeatureLayer({
                    url: Adopted_URL,
                    outFields: ["agn_name", "jobnet_id", "rpt_loc_de", "rpt_rte_na", "rpt_wk_des", "tot_ph_co",
                        "projtype", "fac", "conyear", "ftpm_area", "jurisdiction"],  // not in data "rpt_rte_na", "tot_ph_co", "ftpm_area"
                    popupTemplate: popupTIPpoly,
                    renderer: this.symbolSet.TIP || this.typeRenderer,
                    title: "26-29 TIP Projects",
                    definitionExpression: "",
                    effect: this.focusEffect,
                });

                this.tip_tableLayer = new FeatureLayer({
                    url: Adopted_URL,
                    definitionExpression: this.filter.where || "",
                    listMode: "hide",
                    renderer: this.noRenderer,
                    title: "TIP 26-29 Projects After Amendment 26:3"
                });

                this.amendment_polygons = new FeatureLayer({
                    url: "https://gis.semcog.org/server/rest/services/Hosted/TIP_26_29_Amendment_25_5/FeatureServer/134",
                    //url: "https://gis.semcog.org/server/rest/services/Hosted/TIP_Amendment_2026_3/FeatureServer/146",
                    //url: "https://gis.semcog.org/server/rest/services/Hosted/TIP2629_Final_2025_03_27/FeatureServer/106",
                    //url: "https://gis.semcog.org/server/rest/services/Hosted/TIP2629_Final_2025_04_03/FeatureServer/114",
                    //url: "https://gis.semcog.org/server/rest/services/Hosted/TIP_Amendment_25_3/FeatureServer/122",
                    //url: "https://gis.semcog.org/server/rest/services/Hosted/Amendment25_4_Polygons18Final/FeatureServer/126",
                    //url: "https://gis.semcog.org/server/rest/services/Hosted/TIP_26_29_Amendment_25_5/FeatureServer/134",
                    //url: "https://gis.semcog.org/server/rest/services/Hosted/TIP_26_29_Amendment26_1/FeatureServer/138",
                    //outFields: ["LeadAgency", "JN", "rpt_loc_de", "ProjectName", "ProjectDescription", "tot_prj_co",
                    //     "projtype", "fac", "conyear", "FedPerformArea", "jurisdicti"],
                    outFields: ["agn_name", "jobnet_id", "rpt_loc_de", "rpt_rte_na", "rpt_wk_des", "tot_prj_co",
                         "projtype", "fac", "conyear", "ftpm_area", "jurisdiction", "tot_prj_fe", "tot_prj_st", "tot_prj_lc"],
                    // TODO: Fix Outfields to include all relevant columns for amendment
                    // TODO: Consider changing column names to match TIP layer to simplify filtering

                    popupTemplate: popupAmendmentPoly,
                    renderer: this.symbolSet.Amendment || this.amendmentTypeRenderer,
                    title: "Amendment 26:5 (Full)",
                    definitionExpression: "",
                    effect: this.grayedEffect,
                });

                this.county_layer = new FeatureLayer({
                    url: "https://services1.arcgis.com/xUx8EjNc6egUPYWh/ArcGIS/rest/services/CountyNoShore/FeatureServer/0",
                    renderer: countyRenderer,
                    title: "County Boundaries",
                });

                this.selectLayer = new GraphicsLayer();
                this.map.add(this.selectLayer, 1);
                this.selectSketch = new SketchViewModel({
                    view: this.view,
                    layer: this.selectLayer,
                    pointSymbol: {
                        type: "simple-marker",
                        color: [255, 255, 255, 0],
                        size: "1px",
                        outline: {
                            color: "gray",
                            width: 0
                        }
                    }
                });
                this.selectSketch.on("create", function (event) {
                    if (event.state === "complete") {
                        vue_this.selectLayer.remove(event.graphic);
                        vue_this.selectFeatures(event.graphic.geometry);
                    }
                });

                this.map.add(this.tip_polygons, 10);
                if(this.amendmentOpen) {
                  this.map.add(this.amendment_polygons, 9);
                }
                this.map.add(this.county_layer, 3);
                this.map.add(this.tip_tableLayer, 2);

                this.getData('tip_polygons');
                this.getData('tip_tableLayer');
                if(this.amendmentOpen) {
                    this.getData('amendment_polygons');
                }

                vue_this.$emit('construction_years', vue_this.construction_years)
                vue_this.$emit('FACs', vue_this.FACs)
                vue_this.$emit('project_types', vue_this.project_types)
                vue_this.$emit('jurisdictions', vue_this.jurisdictions)

                this.legend = new Legend({
                    view: this.view,
                    layerInfos: [
                        {
                            layer: this.tip_polygons,
                            title: "TIP Projects"
                        }
                    ]
                });

                let legExpand = new Expand({
                    view: this.view,
                    content: this.legend,
                    expandTooltip: "Legend",
                    expandIconClass: "esri-icon-legend"
                });

                this.measurement = new Measurement({
                    view: this.view,
                    linearUnit: "imperial"
                });

                // Add widget to the bottom right corner of the view
                this.view.ui.add("measureTool", "top-right");
                // this.view.ui.add("selectTools", "top-right");
                //this.view.ui.add("zoomToSelectedButton", "top-right");
                this.view.ui.add("toggleFeatureTable", "bottom-left");
                this.view.ui.add("selectingPopup", "manual");
                this.view.ui.add([
                    {
                        component: legExpand,
                        position: "top-right",
                        index: 2,
                    },
                ]);
                this.featureTable = new FeatureTable({
                    layer: this.tip_tableLayer,
                    view: this.view, // required for feature highlight to work
                    menuConfig: {
                        items: [/*{
                            label: "Zoom to selected feature(s)",
                            iconClass: "esri-icon-zoom-in-magnifying-glass",
                            clickFunction: () => {
                                this.zoomToSelectedFeatures();
                            }
                        },*/
                            {
                                label: "Show all features in table (ignore filters when checked)",
                                //selectionEnabled: true,
                                iconClass: "esri-icon-checkbox-unchecked",
                                clickFunction: (event) => {
                                    this.applyFilterToTable = !this.applyFilterToTable;
                                    if (event.item.selected) {
                                        event.item.iconClass = "esri-icon-checkbox-checked"
                                    } else {
                                        event.item.iconClass = "esri-icon-checkbox-unchecked"
                                    }
                                }
                            }]
                    },
                    fieldConfigs: [
                        {
                            name: "jobnet_id",
                            label: "TIP ID"
                        },
                        {
                            name: "conyear",
                            label: "Year of Obligation"
                        },
                        {
                            name: "phase",
                            label: "Phase"
                        },
                        {
                            name: "otherph",
                            label: "Other Phases"
                        },
                        {
                            name: "projtype",
                            label: "Project Type"
                        },
                        {
                            name: "agn_name",
                            label: "Project Owner"
                        },
                        {
                            name: "rpt_rte_na",
                            label: "Project Name"
                        },
                        {
                            name: "rpt_loc_de",
                            label: "Project Limits"
                        },
                        {
                            name: "rpt_wk_de",
                            label: "Project Description"
                        },
                        {
                            name: "tot_ph_co",
                            label: "Total Phase Cost"
                        },
                        {
                            name: "tot_ph_fe",
                            label: "Federal Phase Cost"
                        },
                        {
                            name: "tot_ph_st",
                            label: "State Phase Cost"
                        },
                        {
                            name: "tot_ph_lc",
                            label: "Local Phase Cost"
                        },
                        {
                            name: "ftpm_area",
                            label: "Performance Area"
                        },
                        {
                            name: "fac",
                            label: "Federal Aid Committee"
                        },
                        {
                            name: "jurisdiction",
                            label: "Jurisdiction"
                        },
                    ],
                    container: this.$refs.featureTable
                });

                this.amendmentFeatureTable = new FeatureTable({
                    layer: this.amendment_polygons,
                    view: this.view, // required for feature highlight to work
                    menuConfig: {
                        items: [/*{
                            label: "Zoom to selected feature(s)",
                            iconClass: "esri-icon-zoom-in-magnifying-glass",
                            clickFunction: () => {
                                this.zoomToSelectedFeatures();
                            }
                        },*/
                            {
                                label: "Show all features in table (ignore filters when checked)",
                                //selectionEnabled: true,
                                iconClass: "esri-icon-checkbox-unchecked",
                                clickFunction: (event) => {
                                    this.applyFilterToTable = !this.applyFilterToTable;
                                    if (event.item.selected) {
                                        event.item.iconClass = "esri-icon-checkbox-checked"
                                    } else {
                                        event.item.iconClass = "esri-icon-checkbox-unchecked"
                                    }
                                }
                            }]
                    },
                    fieldConfigs: [
                        // {
                        //     name: "amends",
                        //     label: "Plan to Amend"
                        // },
                        {
                            name: "jobnet_id",
                            label: "TIP ID"
                        },
                        {
                            name: "conyear",
                            label: "Year of Obligation"
                        },
                        /*{
                            name: "countyregion",
                            label: "County or Region"
                        },*/
                        {
                            name: "agn_name",
                            label: "Lead Agency"
                        },
                        {
                            name: "rpt_rte_na",
                            label: "Project Name"
                        },
                        {
                            name: "rpt_loc_de",
                            label: "Project Limits"
                        },
                        // {
                        //     name: "worktype",
                        //     label: "Primary Work Type"
                        // },
                        {
                            name: "rpt_wk_des",
                            label: "Project Description"
                        },
                        {
                            name: "ftpm_area",
                            label: "Federal Performance Area"
                        },
                        // {
                        //     name: "miles",
                        //     label: "Miles"
                        // },
                        /*{
                            name: "phase",
                            label: "Phase"
                        },*/
                        {
                            name: "tot_prj_co",
                            label: "Total Project Cost"
                        },
                        /*{
                            name: "amendtype",
                            label: "Amendment Type"
                        },
                        {
                            name: "changedescription",
                            label: "Change Description"
                        },
                        {
                            name: "airquality",
                            label: "Air Quality"
                        },*/
                        {
                            name: "projtype",
                            label: "Project Type"
                        },
                        // {
                        //     name: "tot_prj_co",
                        //     label: "Total Cost"
                        // },
                        {
                            name: "tot_prj_fe",
                            label: "Federal Cost"
                        },
                        {
                            name: "tot_prj_st",
                            label: "State Cost"
                        },
                        {
                            name: "tot_prj_lc",
                            label: "Local Cost"
                        },
                        {
                            name: "fac",
                            label: "Federal Aid Committee"
                        },
                        {
                            name: "jurisdiction",
                            label: "Jurisdiction"
                        }
                    ],
                    container: this.$refs.amendmentFeatureTable
                });

                if (this.showTable === "y") {
                    this.showFeatureTable = true;
                }

                if (this.focus === "Amendment") {
                    this.focusAmendment = true;
                }

                // Listen for the table's selection-change event
                this.featureTable.on("selection-change", function (changes) {
                    // If the selection is removed, remove the feature from the array
                    changes.removed.forEach(function (item) {
                        const data = vue_this.selectedFeatures.find(function (data) {
                            return data.feature === item.feature;
                        });
                        if (data) {
                            vue_this.selectedFeatures.splice(vue_this.selectedFeatures.indexOf(data), 1);
                        }
                    });

                    // If the selection is added, push all added selections to array
                    changes.added.forEach(function (item) {
                        const feature = item.feature;
                        vue_this.selectedFeatures.push({
                            feature: feature
                        });
                    });
                    //console.log("After selection change: ", vue_this.selectedFeatures);
                });

                this.tip_tableLayer.watch("loaded", () => {
                    watchUtils.whenFalse(this.view, "updating", () => {
                        // Get the new extent of view/map whenever map is updated AND the featureTable is open
                        if (this.showTable === 'y') {
                            // Filter and show only the visible features in the feature table
                            this.featureTable.filterGeometry = this.view.extent;
                        }
                    });
                });

                this.loaded = true;
            });
    },
    beforeDestroy() {
        if (this.view) {
            // destroy the map view
            this.view.container = null;
        }
    },
    watch: {
        filter: function () {
            if (!this.queryingSelection && this.selectedFeatures.length > 0) {
                this.clearSelection();
            }
            if (this.view && this.tip_polygons && this.amendment_polygons && this.tip_tableLayer) {
                this.view.whenLayerView(this.tip_polygons).then(f => f.filter = this.filter);
                this.view.whenLayerView(this.amendment_polygons).then(f => f.filter = this.filter);
                if (this.applyFilterToTable) {
                    this.tip_tableLayer.definitionExpression = this.filter.where;
                    this.amendment_polygons.definitionExpression = this.filter.where;
                } else {
                    this.tip_tableLayer.definitionExpression = "";
                    this.amendment_polygons.definitionExpression = "";
                }
            }

        },
        symbolSet: {
            deep: true,
            handler() {
                if(this.symbolSet) {
                    this.tip_polygons.renderer = this.symbolSet.TIP;
                    this.amendment_polygons.renderer = this.symbolSet.Amendment;
                }
            }
        },

        focus: function () {
            if (this.focus === "Amendment") {
                this.focusAmendment = true;
            } else {
                this.focusAmendment = false;
            }
        },

        focusAmendment: function () {
            if (this.focusAmendment) {
                this.tip_polygons.effect = this.grayedEffect;
                this.amendment_polygons.effect = this.focusEffect;
                this.map.reorder(this.map.tip_polygons, 9);
                this.map.reorder(this.map.amendment_polygons, 10);
            } else {
                this.tip_polygons.effect = this.focusEffect;
                this.amendment_polygons.effect = this.grayedEffect;
                this.map.reorder(this.map.tip_polygons, 10);
                this.map.reorder(this.map.amendment_polygons, 9);
            }
        },
        applyFilterToTable: function () {
            if (this.applyFilterToTable) {
                this.view.whenLayerView(this.tip_tableLayer).then(() => this.tip_tableLayer.definitionExpression = this.filter.where);
            } else {
                this.view.whenLayerView(this.tip_tableLayer).then(() => this.tip_tableLayer.definitionExpression = "");
            }
        },
    },
}

</script>

<style scoped>

div {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
}

#mapContainer {
    grid-column: 1;
    grid-row: 2;
    position: relative;
    display: grid;
}

@media (max-width: 576px), print {
    #mapContainer {
        height: 75vh;
        grid-row: 3;
    }
}

.active {
    background-color: #d2d2d2;
}

button {
    width: 32px;
    height: 32px;
    font-size: large;
    background: white;

    border-width: 1px;
    border-style: solid;
    border-color: #d2cece;
}

.loadingSpinner {
    float: left;
    vertical-align: middle !important;
}

#featureTableButton:hover, .esri-icon-measure-area:hover, .esri-icon-measure-line:hover,
.esri-icon-erase:hover, .esri-icon-plus-circled:hover, .esri-icon-home:hover,
.esri-icon-minus-circled:hover, .esri-icon-default-action:hover {
    background-color: #f3f3f3;
    cursor: pointer;
}
</style>
